import Styles from "./TeamStaff.module.scss";
import * as Team from "src/state/modules/team";
import { Text } from "src/components/atoms/Text/Text";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";
import { ListRow, ListRowContainer } from "src/components/atoms/ListRow";
import { AvatarTypeOptions, getInitials } from "src/components/atoms/Avatar/Avatar";
import { EmptySection } from "../EmptySection";

interface TeamStaffProps {
  team: Team.Team;
}

// Splits a full staff name ("Kyle Rogers") into the first/last parts getInitials expects so the
// avatar shows "KR". Single-word names fall back to the first two letters.
const staffInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  const firstName = parts[0];
  const lastName = parts.length > 1 ? parts[parts.length - 1] : undefined;
  return getInitials({ firstName, lastName });
};

export const TeamStaff = ({ team }: TeamStaffProps) => {
  // `staff` is a list of names, or the sentinel string "No Staff Found" when none are present.
  const staff = Array.isArray(team.staff) ? team.staff : [];

  if (staff.length === 0) {
    return <EmptySection iconType={"people"} message={"No staff added"} />;
  }

  const sortedStaff = [...staff].sort((a, b) => a.localeCompare(b));

  return (
    <>
      <OldRow padded={false} className={Styles.staffHeaderRow}>
        <Text size={"medium"} weight={"bold"}>
          <>Team Staff ({`${sortedStaff.length}/${sortedStaff.length}`})</>
        </Text>
      </OldRow>
      <ListRowContainer>
        {sortedStaff.map((name) => (
          <ListRow
            key={name}
            mainContent={name}
            avatar={{ type: AvatarTypeOptions.Person }}
            intitials={staffInitials(name)}
          />
        ))}
      </ListRowContainer>
    </>
  );
};
